let lastSearch;
window.articuloExcluidoPorExclusionPPCTA = false;
window.totalSearchResults                = 0

$(function () {
    inicializarBusquedaMenu();
});

/**
 * Initialize the searcher
 */
function inicializarBusquedaMenu() {
    $(document).on(
        'keypress click',
        '#busquedaMenuFormularioCampoTitulo, #busquedaMenuFormularioBotonEnviar',
        function (event) {
            if (
                (
                    event.currentTarget.localName === 'input' &&
                    event.type === 'keypress' &&
                    event.which === 13
                ) ||
                (
                    event.currentTarget.localName === 'button' &&
                    event.type === 'click'
                )
            ) {
                if (!$('#busquedaMenuFormulario')[0].checkValidity()) {
                    $("<input type=\"submit\">")
                        .hide()
                        .appendTo('#busquedaMenuFormulario')
                        .click()
                        .remove();
                } else {
                    event.preventDefault();
                    let tipo        = $('#busquedaMenuFormularioSelectTipoArticulo').val();
                    window.location = `${urlArticulo}?buscador=${encodeURIComponent($('#busquedaMenuFormularioCampoTitulo').val())}${tipo !== '*' ? '&tipo=' + tipo : ''}`;
                }
            }
        }
    );

    inicializarBloodhoundYTypeahead(
        'busquedaMenuFormularioCampoTitulo',
        'busquedaMenuFormularioSelectTipoArticulo', function (obj, datum) {
            window.location = urlArticulo + '/' + datum.id;
        }
    );
}

/**
 *
 * @param typeaheadInputSelectorId id del input de typeahead
 * @param tipoArticuloSelectorId Id del select de tipo de artículo
 * @param callback Función a ejecutar al seleccionar un elemento
 */
window.inicializarBloodhoundYTypeahead = function (typeaheadInputSelectorId, tipoArticuloSelectorId = null, callback = function (obj, datum) {
}) {
    let ttaSearchArticles = inicializarBloodhound(tipoArticuloSelectorId);
    ttaSearchArticles.initialize();
    inicializarTypeahead(typeaheadInputSelectorId, ttaSearchArticles, callback);
}

/**
 * Initialize the searcher
 * @param tipoArticuloSelectorId Id del select de tipo de artículo
 * @returns {Bloodhound}
 */
window.inicializarBloodhound = function (tipoArticuloSelectorId = null) {
    let ttaSearchArticles = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('idarticulo'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        // limit: 31,
        remote: {
            url:     urlArticulo + '/get-ta',
            prepare: function (query, settings) {
                settings.type        = 'POST';
                settings.contentType = 'application/json; charset=UTF-8';
                settings.data        = JSON.stringify({
                    // Establezco los parámetros a obtener en la consulta
                    searchFields:   {
                        buscador: query.trim(),
                        tipo:     $(`#${tipoArticuloSelectorId}`).val() !== undefined ? $(`#${tipoArticuloSelectorId}`).val() : '*',
                    },
                    orderBy:        [
                        'ventas',
                        'titulo'
                    ],
                    orderDir:       [
                        'desc',
                        'asc'
                    ],
                    resultsPerPage: 30,
                });
                settings.beforeSend  = function (e) {
                    if (lastSearch) {
                        lastSearch.abort();
                    }
                    lastSearch = e;
                };
                settings.error       = function (jqXHR, textStatus, errorThrown) {
                    let errors = '';
                    if (jqXHR.status === 422) {
                        errors = composeValidationError(jqXHR.responseJSON.errors);
                    } else if (
                        typeof jqXHR.responseJSON !== 'undefined' &&
                        typeof jqXHR.responseJSON.message !== 'undefined'
                    ) {
                        errors = jqXHR.responseJSON.message;
                    }
                    if (errors.length) {
                        pNotifyError(errors);
                    }
                };
                return settings;
            },
            filter:  function (list) {
                if (typeof list === 'object' && list !== null) {
                    if (list.hasOwnProperty('benchmark')) {
                        // Eliminar el elemento benchmark del objeto original
                        delete list.benchmark;
                    }

                    // Si existe la propiedad excluidoPorPPCTA, la guardamos en una variable global para usarla en el template
                    articuloExcluidoPorExclusionPPCTA = list.hasOwnProperty('excluidoPorPPCTA');

                    // Convertir el resto del objeto en un array
                    list = Object.values(list);
                }
                totalSearchResults = list[list.length - 1];
                return list;
            },
            ttl:     false,
        },
    });
    return ttaSearchArticles;
}

/**
 *
 * @param typeaheadInputSelectorId Id del input de typeahead
 * @param ttaSearchArticles creada con inicializarBloodhound
 * @param callback Función a ejecutar al seleccionar un elemento
 */
window.inicializarTypeahead = function (typeaheadInputSelectorId, ttaSearchArticles, callback = function (obj, datum) {
}) {
    $(`#${typeaheadInputSelectorId}`)
        .typeahead(
            {
                hint:      false,
                minLength: 3,
                highlight: true,
            },
            {
                name:       'SearchArticles',
                displayKey: 'titulo',
                // La previsualización sigue mostrando como máximo 30 artículos. La respuesta contiene hasta
                // 30 artículos más un elemento adicional con numFound. Typeahead 0.11.1 incrementa rendered
                // antes de aplicar slice(0, limit - rendered), por lo que 61 = 2 * 30 + 1 evita eliminar
                // sugerencias válidas sin aumentar el máximo de artículos devuelto por Solr.
                limit: 61,
                // source:    throttle(ttaSearchArticles.ttAdapter(), 500),
                source:    ttaSearchArticles.ttAdapter(),
                templates: {
                    header: function (context) {
                        // Pintamos el último elemento devuelto en el array
                        return `<div class="tt-header">
                                    <b>${transBusquedaCoincidencias}: <span class="text-secondary">${articuloExcluidoPorExclusionPPCTA ? 0 : totalSearchResults}</span></b>
                                </div>`;
                    },
                    // Mensaje de carga
                    notFound:   function (event) {
                        return `<div class="col text-center p-2">
                                    <i class="ri-loader-4-line spinner align-middle me-2"></i>${transAccionBuscando}
                                </div>`;
                    },
                    suggestion: function (result) {
                        // Check if the article is zero
                        if (result === 0) {
                            // Return the 'no results' option
                            // Si el artículo no se encuentra por exclusión PPCTA, mostramos el correspondiente mensaje informativo
                            return `<div class="tt-notFound col text-center text-warning p-3">
                                        ${articuloExcluidoPorExclusionPPCTA ? `<span style="font-size:20px; color:#000;"><i class="ri-alarm-warning-fill align-middle text-warning"></i> ${transArticuloInfoExclusionPPCTA}</span>` : `<i class="ri-alarm-warning-fill align-middle ri-lg"></i>${transErrorNoEncontradoArticulos}`}
                                        <br/>
                                        <small class="text-muted">${articuloExcluidoPorExclusionPPCTA ? '' : ucfirst(transArticuloInfoSolicitud)}</small>
                                    </div>`;
                        }

                        // Check if the product is undefined
                        if (typeof result.id === 'undefined') {
                            // Return an empty div
                            return '<div class="d-none"></div>';
                        }

                        // Suggestion
                        return `<div class="p-2">
                                    <div class="suggestionContainerImage">
                                        <img class="suggestionImage" src="${result.imagen}_thumb" alt="${result.titulo}">
                                    </div>
                                    <div class="suggestionContent">
                                        <div class="suggestionHeader">
                                            <span class="suggestionTitle">${result.titulo}</span>
                                            <span class="suggestionPublisher">${result.editorial}</span>
                                            <!--
                                            <span class="suggestionPrice d-none">${parseFloat('32,69').toFixed(2).replace('.', ',')} €</span>
                                            -->
                                        </div>
                                        <!--
                                        <div class="suggestionBody">
                                            <span class="suggestionEan">${typeof result.ean !== 'undefined' ? result.ean : '&nbsp;'}</span>
                                            <span class="suggestionAuthor">${typeof result.autor !== 'undefined' ? result.autor : '&nbsp;'}</span>
                                        </div>
                                        -->
                                    </div>
                                </div>`;
                    },
                },
            }
        )
        .on('typeahead:select', function (obj, datum) {
            $(`#${typeaheadInputSelectorId}`).typeahead('val', '');
            callback(obj, datum);
        });
}
